import { createRouter, createWebHistory } from 'vue-router'
import { useAuthStore } from '../stores/auth'

const router = createRouter({
  history: createWebHistory(),
  routes: [
    { path: '/', redirect: '/dashboard' },
    { path: '/signup', name: 'signup', component: () => import('../views/SignupView.vue'), meta: { public: true } },
    { path: '/login', name: 'login', component: () => import('../views/LoginView.vue'), meta: { public: true } },
    { path: '/choose-company', name: 'choose-company', component: () => import('../views/ChooseCompanyView.vue'), meta: { bare: true } },
    { path: '/dashboard', name: 'dashboard', component: () => import('../views/DashboardView.vue'), meta: { tab: 'dashboard' } },
    { path: '/shifts', name: 'shifts', component: () => import('../views/ShiftsView.vue'), meta: { tab: 'shifts' } },
    { path: '/shifts/new', name: 'post-shift', component: () => import('../views/PostShiftView.vue'), meta: { tab: 'shifts', requiresManage: true } },
    { path: '/shifts/:id', name: 'shift-detail', component: () => import('../views/ShiftDetailView.vue'), meta: { tab: 'shifts' } },
    // Left running on a tablet by the door, so it needs no chrome and no
    // navigation — hence `bare`.
    { path: '/sites/:id?/qr', name: 'site-qr', component: () => import('../views/SiteQrView.vue'), meta: { bare: true } },
    { path: '/timesheets', name: 'timesheets', component: () => import('../views/TimesheetsView.vue'), meta: { tab: 'timesheets' } },
    { path: '/workers', name: 'workers', component: () => import('../views/WorkersView.vue'), meta: { tab: 'workers' } },
    { path: '/billing', name: 'billing', component: () => import('../views/BillingView.vue'), meta: { tab: 'billing', requiresBilling: true } },
    { path: '/:pathMatch(.*)*', redirect: '/dashboard' },
  ],
  scrollBehavior: () => ({ top: 0 }),
})

router.beforeEach(to => {
  const auth = useAuthStore()

  if (to.meta.public) return auth.isAuthenticated ? { name: 'dashboard' } : true
  if (!auth.isAuthenticated) return { name: 'login' }

  // Every scoped screen needs an active org — without it, tenant filtering
  // has nothing to filter by and the backend would refuse the request.
  if (!auth.activeOrgId && to.name !== 'choose-company') return { name: 'choose-company' }

  if (to.meta.requiresManage && !auth.canManageShifts) return { name: 'dashboard' }
  if (to.meta.requiresBilling && !auth.canManageBilling) return { name: 'dashboard' }
  return true
})

export default router
